module.exports = __webpack_public_path__ + "static/media/plants.488bf064.svg";